import { render } from "./dialog-bill-reapply.vue?vue&type=template&id=21b0945a&ts=true"
import script from "./dialog-bill-reapply.vue?vue&type=script&lang=ts"
export * from "./dialog-bill-reapply.vue?vue&type=script&lang=ts"

import "./dialog-bill-reapply.vue?vue&type=style&index=0&id=21b0945a&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__